import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  Context,
  fetchClasses,
  newClassPath,
  editClassPath,
  classesPath,
  bulkEditClassesPath,
  fetchTeachers,
} from "../../../managerStore";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import ClassList from "../../../templates/manager/ClassList";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const history = useHistory();
  const { currentYear } = useCurrentYear();

  React.useEffect(() => {
    dispatch(fetchClasses(currentYear));
  }, [dispatch, currentYear]);

  React.useEffect(() => {
    dispatch(fetchTeachers());
  }, [dispatch]);

  const toBuildNewClass = React.useCallback(
    () => history.push(newClassPath),
    [history],
  );
  const toBuildClass = React.useCallback(
    id => {
      history.push(`${editClassPath}/${id}`);
    },
    [history],
  );

  const toBulkEditClasses = React.useCallback(
    () => history.push(bulkEditClassesPath),
    [history],
  );

  const changeYear = React.useCallback(
    y => {
      history.push(`${classesPath}/${y}`);
    },
    [history],
  );

  return (
    <div>
      <Breadcrumb currentTitle={titles.classes} />
      <ClassList
        title={titles.classes}
        year={currentYear}
        teachers={state.teachers}
        isNextYear={false}
        changeYear={changeYear}
        toBuildNewClass={toBuildNewClass}
        toBuildClass={toBuildClass}
        toBulkEditClasses={toBulkEditClasses}
        classes={state.classes}
      />
    </div>
  );
};
